import { render, staticRenderFns } from "./Vente.vue?vue&type=template&id=621c837a&scoped=true&"
import script from "./Vente.vue?vue&type=script&lang=js&"
export * from "./Vente.vue?vue&type=script&lang=js&"
import style0 from "./Vente.vue?vue&type=style&index=0&id=621c837a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c837a",
  null
  
)

export default component.exports